import { Box, Drawer } from '@material-ui/core';

import { PricingFormWrapper } from '@/components/modules/PricingCreate/components/PricingFormWrapper';
import { PricingSpecByIdFormSchema } from '@/components/modules/PricingEditor/schemas/PricingSpecByIdFormSchema';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

import { usePricingEditor } from '../hooks/usePricingEditor';

type PricingSpecFormValues = {
  pricingSpecId: string;
};

interface PricingSpecFormByIdProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pricingId: string;
  defaultValues?: PricingSpecFormValues;
}

export const PricingSpecByIdForm = ({ open, setOpen, pricingId }: PricingSpecFormByIdProps) => {
  const { addPricingSpecToPricing, loading } = usePricingEditor(pricingId);

  const onSubmit = async (data: PricingSpecFormValues) => {
    addPricingSpecToPricing(data.pricingSpecId);
    setOpen(false);
  };

  return (
    <Drawer anchor={'bottom'} open={open} onClose={() => setOpen(false)}>
      <Box p={6}>
        <Box mb={5}>
          <Font variant={'h3'} color={'title'}>
            <Text tId={'ADD_NEW_PRICING_SPEC'} />
          </Font>
        </Box>
        <PricingFormWrapper formSchema={PricingSpecByIdFormSchema} onSubmitForm={onSubmit} loading={loading}>
          <main style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <section
              style={{
                width: '100%',
                display: 'flex',
                paddingBottom: 32,
              }}
            >
              <TextFormField autoFocus name={'pricingSpecId'} label={'pricingSpecId'} />
            </section>
          </main>
        </PricingFormWrapper>
      </Box>
    </Drawer>
  );
};
